import { applyAggregateErrorsToEvent, exceptionFromError } from '@sentry/utils';
import { convertIntegrationFnToClass, defineIntegration } from '../integration.js';
var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
var INTEGRATION_NAME = 'LinkedErrors';
var _linkedErrorsIntegration = function _linkedErrorsIntegration() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var limit = options.limit || DEFAULT_LIMIT;
  var key = options.key || DEFAULT_KEY;
  return {
    name: INTEGRATION_NAME,
    // TODO v8: Remove this
    setupOnce: function setupOnce() {},
    // eslint-disable-line @typescript-eslint/no-empty-function
    preprocessEvent: function preprocessEvent(event, hint, client) {
      var options = client.getOptions();
      applyAggregateErrorsToEvent(exceptionFromError, options.stackParser, options.maxValueLength, key, limit, event, hint);
    }
  };
};
var linkedErrorsIntegration = defineIntegration(_linkedErrorsIntegration);

/**
 * Adds SDK info to an event.
 * @deprecated Use `linkedErrorsIntegration()` instead.
 */
// eslint-disable-next-line deprecation/deprecation
var LinkedErrors = convertIntegrationFnToClass(INTEGRATION_NAME, linkedErrorsIntegration);
export { LinkedErrors, linkedErrorsIntegration };